export * from './Modality';
export * from './PatientHistory';
export * from './preset';
export * from './resource';
export * from './rpcCommands';
export * from './Session';

export const WADO_URI = 'wado-uri';
export const QIDO_RS = 'qido-rs';
export const WADO_RS = 'wado-rs';
export enum LocalForageKey {
	Preset = 'preset',
}
export const toolGroupIds = ['default', 'mpr', 'SRToolGroup', 'volume3d', 'ctToolGroup', 'ptToolGroup', 'fusionToolGroup'];
export enum MprPlanes {
	Axial = 'Axial',
	Coronal = 'Coronal',
	Sagittal = 'Sagittal',
	Oblique = 'Oblique',
}

export enum SettingGroupID {
	default = 'default',
	mpr = 'mpr',
	remoteRender3D = 'remoteRender3D',

	remoteMPR = 'remoteMPR',
	clientRender3D = 'clientRender3D',
	fusionPetCT = 'fusionPetCT',
	remoteRenderEndo = 'remoteRenderEndo',
	mammo = 'mammo',
	dicomPrint = 'dicomPrint',

	/// Key quản lý chọn client hay server
	renderMPR = 'renderMPR',
	render3D = 'render3D',
}
// viewId theo server, client dùng để tạo view stream
export enum REMOTE_VIEW_ID {
	'3D' = '1',
	ENDO = '1',
	AXIAL = '2',
	CORONAL = '3',
	SAGITTAL = '4',
}

export type ICallback = (...args) => void;
